// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1xxuc","containerItemsCenter":"Skeleton_containerItemsCenter__QRgCJ"};